import { CheckCircle, Clock, XCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useBlobIndexStatus } from "@/hooks/useBlobIndexStatus";

interface BlobIndexStatusProps {
  blobName: string;
}

export function BlobIndexStatus({ blobName }: BlobIndexStatusProps) {
  const { t } = useTranslation();
  const { data: isIndexed, isLoading, isError } = useBlobIndexStatus(blobName);

  if (isLoading) {
    return (
      <span className={"text-gray-400"} title={t("knowledgeBase.indexStatus.checking")}>
        <Clock className="w-3 h-3 mr-1" />
      </span>
    );
  }

  if (isError) {
    return (
      <div className="flex items-center text-xs text-gray-400">
        <span title={t("knowledgeBase.indexStatus.unknown")}>
          <XCircle className="w-3 h-3 mr-1" />
        </span>
      </div>
    );
  }

  return (
    <div className={`flex items-center text-xs ${isIndexed ? 'text-green-600' : 'text-orange-500'}`}>
      {isIndexed ? (
        <span title={t("knowledgeBase.indexStatus.indexed")}>
          <CheckCircle className="w-3 h-3 mr-1" />
        </span>
      ) : (
        <span title={t("knowledgeBase.indexStatus.notIndexed")}>
          <Clock className="w-3 h-3 mr-1" />
        </span>
      )}
    </div>
  );
}
